import { COL_OFFSET } from '@/domain/mitarbeiter/features/rotationsplan/constants';
import { KalenderArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/KalenderArbeitsbereich';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { getColorsForMarkierung } from '@/domain/mitarbeiter/features/rotationsplan/utils/getColorForMarkierung';
import { KalenderMitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/KalenderMitarbeiter';

interface Station {
  id: string;
  von: Date;
  bis: Date;
  getColStart(): number;
  getColEnd(): number;
  abschnittId: string;
}

export class KalenderArbeitsbereichStation implements Station {
  constructor({
    von,
    bis,
    id,
    mitarbeiter,
    abschnittId,
  }: {
    von: Date;
    bis: Date;
    id: string;
    mitarbeiter: KalenderMitarbeiter[];
    abschnittId: string;
  }) {
    this.mitarbeiter = mitarbeiter;
    this.von = von;
    this.bis = bis;
    this.id = id;
    this.abschnittId = abschnittId;
  }

  id: string;
  von: Date;
  bis: Date;
  mitarbeiter: KalenderMitarbeiter[];
  abschnittId: string;

  getColStart(): number {
    const week = dayjs(this.von).isoWeek();
    const weekday = dayjs(this.von).isoWeekday();
    return (week - 1) * 7 + weekday + COL_OFFSET;
  }

  getColEnd(): number {
    const week = dayjs(this.bis).isoWeek();
    const weekday = dayjs(this.bis).isoWeekday();
    // Da grid-col-end exklusiv ist, müssen wir neben dem Offset noch mal 1 drauf rechnen
    return (week - 1) * 7 + weekday + COL_OFFSET + 1;
  }
}

export class KalenderMitarbeiterStation implements Station {
  constructor({
    von,
    bis,
    id,
    arbeitsbereich,
    abschnittId,
  }: {
    von: Date;
    bis: Date;
    id: string;
    arbeitsbereich: KalenderArbeitsbereich;
    abschnittId: string;
  }) {
    this.arbeitsbereich = arbeitsbereich;
    this.von = von;
    this.bis = bis;
    this.id = id;
    this.abschnittId = abschnittId;
  }

  id: string;
  von: Date;
  bis: Date;
  arbeitsbereich: KalenderArbeitsbereich;
  abschnittId: string;

  getColStart(): number {
    const week = dayjs(this.von).isoWeek();
    const weekday = dayjs(this.von).isoWeekday();
    return (week - 1) * 7 + weekday + COL_OFFSET;
  }

  getColEnd(): number {
    const week = dayjs(this.bis).isoWeek();
    const weekday = dayjs(this.bis).isoWeekday();
    // Da grid-col-end exklusiv ist, müssen wir neben dem Offset noch mal 1 drauf rechnen
    return (week - 1) * 7 + weekday + COL_OFFSET + 1;
  }

  getFillColor(): string {
    return getColorsForMarkierung(this.arbeitsbereich.markierung).light;
  }

  getBorderColor(): string {
    return getColorsForMarkierung(this.arbeitsbereich.markierung).base;
  }
}
